import { Component, OnInit } from '@angular/core';
import { CompanySwitcherSessionService } from '../layout/company-switcher/company-switcher-session.service';
import { StorageManager } from '@app/services/storage-manager.service';
import { SendbirdConnectionManagerV4Service } from '@app/dashboard/messaging/services/sendbird-connection-manager-v4.service';
import { RemoteLoginService } from '@app/lib/remote-login';
import { StatsigService } from '@app/services/statsig.service';
import { EnterprisePlatformFeatureFlagService } from '@app/services/feature-flags/enterprise-platform';
import { ServiceWorkerService } from '@app/services/sw.service';
import { LogoutBroadcastChannelService } from '@services/logout-broadcast-channel.service';
import { getAccountUrl } from '@lib/environments.const';
import { clearAllCookies } from '@lib/logout-utils';

const ACCOUNT_URL = getAccountUrl();

@Component({
  selector: 'logout',
  template: '',
})
export class LogoutComponent implements OnInit {

  constructor(
    private companySwitcherSessionService: CompanySwitcherSessionService,
    private storageManager: StorageManager,
    private remoteLoginService: RemoteLoginService,
    private sendbirdConnectionManagerProviderService: SendbirdConnectionManagerV4Service,
    private statsigService: StatsigService,
    private enterprisePlatformFeatureFlagService: EnterprisePlatformFeatureFlagService,
    private serviceWorkerService: ServiceWorkerService,
    private logoutBroadcastChannelService: LogoutBroadcastChannelService,
  ) {}

  public ngOnInit(): void {
    /*
     * logoutBroadcastChannelService.emitLogoutEventToAllTabs() should be added at the top of function so that it
     * gets called immediately on other tabs.
    */
    this.logoutBroadcastChannelService.emitLogoutEventToAllTabs();
    this.serviceWorkerService.unregisterServiceWorkers();
    if (!this.enterprisePlatformFeatureFlagService.skipCookieClear()) {
      clearAllCookies();
    }
    // Delete cookie containing session information. This prevents the sharing of this
    // info across different users as well as different sessions of same user.
    this.storageManager.clearLocalStorage().then(() => window.location.href = `${ACCOUNT_URL}/sign_out`);
    this.sendbirdConnectionManagerProviderService.disconnect();
    this.statsigService.shutdown();

    // Reset adaEmbed if it exists
    // to clear out the chat history and start fresh
    // in the next session
    if (window['adaEmbed']) {
      window['adaEmbed'].reset();
    }
  }
}
